import http from "@/http-common";
/**
 * Clase espejo de los endpoint de Licences
 */
class Licences {
  getLicences(filterParams) {
    return http.get("licences/", { params: filterParams });
  }
  putLicences(id_local_licence, local_licence) {
    return http.put("licences/" + id_local_licence, local_licence);
  }
  deletLicences(idLicence) {
    return http.delete("licences/" + idLicence);
  }
  postLicences(local_licence) {
    return http.post("licences/", local_licence);
  }

  getSiteUnirGroups(licenceId, site, userId) {
    return http.get(
      "licences/" + licenceId + "/site/" + site + "/unirgroups/" + userId
    );
  }

  getCurrentUserSiteUnirGroups(licenceId, site) {
    return http.get(
      "licences/" + licenceId + "/site/" + site + "/currentuser/unirgroups"
    );
  }
}

export default new Licences();
